<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';

const navbarHeight = ref(50);
let navbarObserver: MutationObserver | null = null;

onMounted(() => {
    const navbarElement = document.querySelector('.app-header') as HTMLElement | null;
    if (navbarElement) {
        navbarHeight.value = navbarElement.clientHeight;
        navbarObserver = new MutationObserver(() => {
            navbarHeight.value = navbarElement.clientHeight;
        });
        navbarObserver.observe(navbarElement, { attributes: true, childList: true, subtree: true });
    } 
});
onUnmounted(() => {
    if (navbarObserver) {
        navbarObserver.disconnect();
        navbarObserver = null;
    }
});
</script>

<template>
    <div>
        <div class="loading-overlay" :style="{ top: navbarHeight + 'px' }" />
        <div class="loading-container" :style="{ top: navbarHeight + 'px' }">
            <VLProgressBar mode="indeterminate" style="height: 6px; width: 100%;" :pt="{ value: { style: 'background: #0284C7' } }" />
        </div>
    </div>
</template>
<style scoped>
.loading-overlay {
    position: fixed;
    left: 0;
    width: 100%;
    height: calc(100vh - var(--navbar-height, 50px));
    background: rgba(255, 255, 255, 0.25);
    z-index: 999;
    pointer-events: all;
}

.loading-container {
    position: fixed;
    width: 100%;
    left: 0;
    z-index: 1001;
}
</style>
